import React from 'react';
import styled from 'styled-components/macro';
import { LinkStyled, Span } from '../../typography';
import { MomsChange, Money } from '../../../containers/commerce';
import { Div } from '../../grid';
import { Image } from '../../Image';
import BuyButtonsFadoel from '../Item/BuyButtonsFadoel';

const FlexGrid = styled(Div)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding: 15px;
  height: calc(100% - 30px);

  ${({ green, theme }) => green && `
    background-color: ${theme.colors.colorGreenHighlight};
  `}

  @media (max-width: 1599px) {
    justify-content: space-around;
  }
`;

const FlexContent = styled(Div)`
  ${({ kulsyreOpfyldning }) => kulsyreOpfyldning ? `
    flex: 0 0 100%;
  ` : `
    flex: 0 0 60%;

    @media (max-width: 1599px) {
      flex: 0 0 75%;
    }

    @media (max-width: 575px) {
      flex: 0 0 100%;
    }
  `
  }
`;

const ImageWrap = styled(Div)`
  display: flex;
  align-items: ${({ middleImage }) => (middleImage ? 'center' : 'flex-start')};
  justify-content: center;
  flex: 0 0 calc(40% - 30px);
  padding: 15px;

  @media (max-width: 1599px) {
    flex: 0 0 calc(25% - 30px);
  }

  @media (max-width: 575px) {
    align-items: center;
    text-align: center;
    flex: 0 0 calc(100% - 30px);
  }
`;

const ImageStyled = styled(Image)`
  @media (max-width: 1599px) {
    max-height: 280px;
  }

  @media (max-width: 575px) {
    max-height: 150px;
  }
`;

const NameLink = styled(LinkStyled)`
  color: ${({ theme }) => theme.colors.colorGreyDark};
  font-family: 'Inter',sans-serif;
  font-weight: bold;
  text-transform: uppercase;
`;

const Name = styled(Span)`
  color: ${({ theme }) => theme.colors.colorGreyDark};
  font-family: 'Inter',sans-serif;
  font-weight: bold;
  text-transform: uppercase;
`;
const RenderName = ({
  url,
  urlDontShow,
  name,
}) => {
  if (url && !urlDontShow) {
    return (
      <NameLink to={url}>
        {name}
      </NameLink>
    );
  }
  return (
    <Name>
      {name}
    </Name>
  );
};

const PriceStyled = styled(Money)`
  font-size: 24px;
  font-weight: bold;
`;

const PriceWrap = styled(Div)`
  margin: 15px 0;
`;

const RenderPrice = ({
  price,
  priceSuffix,
}) => (
  <PriceWrap>
    <PriceStyled money={price} />{priceSuffix && (priceSuffix)}<br /><MomsChange />
  </PriceWrap>
);

const DescriptionWrap = styled(Div)`
  margin: 15px 0;

  & > p {
    font-size: 14px;
  }
`;

const RenderDescription = ({
  customDescription,
  description,
  tooltip,
  secondDescription,
}) => {
  if (customDescription) {
    return (
      <DescriptionWrap>
        {customDescription}
      </DescriptionWrap>
    );
  }
  if (secondDescription && description) {
    return (
      <DescriptionWrap>
        {secondDescription}
        {description()}
      </DescriptionWrap>
    );
  }
  if (description) {
    return (
      <DescriptionWrap>
        {description()}
      </DescriptionWrap>
    );
  }
  if (tooltip) {
    return (
      <DescriptionWrap>
        {tooltip()}
      </DescriptionWrap>
    );
  }
  return null;
};

export default function ProductViewKulsyre({
  name,
  url,
  price,
  amount,
  imageSingle,
  description,
  customDescription,
  tooltip,
  actions,
  middleImage,
  extraItemRef,
  secondDescription,
  priceSuffix,
  kulsyreOpfyldning,
  urlDontShow,
}) {
  return (
    <FlexGrid green={amount > 0} ref={extraItemRef}>
      {!kulsyreOpfyldning && (
        <ImageWrap>
          <ImageStyled
            imageHeight="320px"
            name={imageSingle}
            middleImage={middleImage}
            className="bucketAnimation"
          />
        </ImageWrap>
      )}
      <FlexContent kulsyreOpfyldning={kulsyreOpfyldning}>
        <RenderName url={url} name={name} urlDontShow={urlDontShow} />
        <RenderDescription customDescription={customDescription} description={description} secondDescription={secondDescription} tooltip={tooltip} />
        <RenderPrice price={price} priceSuffix={priceSuffix} />
        <BuyButtonsFadoel fullWidth amount={amount} actions={actions} />
      </FlexContent>
    </FlexGrid>
  );
}
